/**
 * Décor SVG des vues SENTIER par région — pur data (comme ileShape.js) :
 * la silhouette du sommet en tête de sentier + la lueur d'ambiance.
 * Remplaçable sans toucher aux composants le jour d'une vraie DA.
 *
 * Chaque sommet : { fond (gradient CSS d'ambiance), viewBox, elements[] }
 * — elements = paths empilés (silhouettes navy + accents de couleur).
 */

/**
 * Scène EXTÉRIEURE du Volcan des Nombres (VolcanRegion) — montagne de nuit,
 * coulée de lave, contreforts. Les dégradés (roche, lave) sont déclarés en
 * <defs> par le composant ; ici uniquement les tracés.
 */
export const VOLCAN_EXT = {
    viewBox: '0 0 1000 620',
    montagne: 'M0,620 L250,240 Q310,200 370,225 L430,205 Q500,175 570,205 L640,228 Q700,205 755,242 L1000,620 Z',
    bouche: 'M418,214 Q500,186 582,216 L560,238 Q500,214 442,236 Z',
    coulee: 'M500,225 q-14,60 8,110 q18,44 -6,95 q-20,46 4,110 l38,80 h-70 l16,-72 q16,-52 -6,-98 q-20,-46 4,-96 q18,-44 -8,-96 z',
    contrefortG: 'M300,620 L420,430 L470,620 Z',
    contrefortD: 'M700,620 L600,470 L560,620 Z',
};

export const SOMMETS = {
    // Le Volcan des Nombres (Piton de la Fournaise) : crêtes anguleuses,
    // cratère incandescent.
    volcan: {
        fond: 'radial-gradient(ellipse at 50% 0%, rgba(249,115,22,.22), transparent 65%)',
        viewBox: '0 0 320 110',
        elements: [
            { d: 'M0,110 L70,58 L105,78 L158,16 L205,66 L250,44 L320,110 Z', fill: '#0E2A4D', opacity: 0.92 },
            { d: 'M148,28 L158,16 L168,28 L163,33 L153,33 Z', fill: '#F97316', opacity: 0.85 },
            { d: 'M120,110 L158,52 L196,110 Z', fill: '#122E54', opacity: 0.65 },
        ],
    },
    // La Forêt des Mots (Roche Écrite) : canopée arrondie, cimes émergentes.
    foret: {
        fond: 'radial-gradient(ellipse at 50% 0%, rgba(31,157,85,.20), transparent 65%)',
        viewBox: '0 0 320 110',
        elements: [
            { d: 'M0,110 Q28,62 58,94 Q82,50 112,88 Q142,42 172,86 Q202,52 232,90 Q266,58 320,110 Z', fill: '#0E2A4D', opacity: 0.92 },
            { d: 'M100,88 L112,62 L124,88 Z', fill: '#1F9D55', opacity: 0.55 },
            { d: 'M158,86 L172,56 L186,86 Z', fill: '#1F9D55', opacity: 0.7 },
            { d: 'M214,90 L226,66 L238,90 Z', fill: '#1F9D55', opacity: 0.55 },
        ],
    },
};
